<nav class="sidebar sidebar-offcanvas" id="sidebar">

  <ul class="nav">
    <!-- Nav -->
    <li class="nav-item nav10" (click)="toValhalla(10)">
      <a class="nav-link" [routerLink]="['/dashboard']">
        <i class="ti-bell menu-icon"></i>
        <span class="menu-title">Dashboard</span>
      </a>
    </li>
    <!-- Nav -->

    <div class="line my-1">
      <svg width="224" height="1" viewBox="0 0 224 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="0.5" x2="224" y2="0.5" stroke="#E1E1FB" />
      </svg>
    </div>


    <li class="list-divider"></li>

    <!-- Nav Single -->
    <li class="nav-item nav20" (click)="toValhalla(20)" [routerLink]="['/dashboard/faculty-management']">
      <a class="nav-link">
        <i class="ti-bar-chart-alt menu-icon"></i>
        <span class="menu-title">Faculty Database</span>
      </a>
    </li>
    <!-- Nav Single -->

    <!-- Nav Single -->
    <li class="nav-item nav21" (click)="toValhalla(21)" [routerLink]="['/dashboard/student-management']">
      <a class="nav-link">
        <i class="ti-bookmark-alt menu-icon"></i>
        <span class="menu-title">Student Database</span>
      </a>
    </li>
    <!-- Nav Single -->

    <div class="line my-1">
      <svg width="224" height="1" viewBox="0 0 224 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="0.5" x2="224" y2="0.5" stroke="#E1E1FB" />
      </svg>
    </div>


    <!-- Nav Single -->
    <li class="nav-item nav30" (click)="toValhalla(30)" [routerLink]="['/dashboard/department-management']">
      <a class="nav-link">
        <i class="ti-layers-alt menu-icon"></i>
        <span class="menu-title">Departments</span>
      </a>
    </li>
    <!-- Nav Single -->


    <!-- Nav Single -->
    <li class="nav-item nav40" (click)="toValhalla(40)" [routerLink]="['/dashboard/classroom-management']">
      <a class="nav-link">
        <i class="ti-user menu-icon"></i>
        <span class="menu-title">Classrooms</span>
      </a>
    </li>
    <!-- Nav Single -->


    <!-- Nav Single -->
    <li class="nav-item nav50" (click)="toValhalla(50)" [routerLink]="['/dashboard/subject-management']">
      <a class="nav-link">
        <i class="ti-money menu-icon"></i>
        <span class="menu-title">Subjects</span>
      </a>
    </li>
    <!-- Nav Single -->

    <div class="line my-1">
      <svg width="224" height="1" viewBox="0 0 224 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="0.5" x2="224" y2="0.5" stroke="#E1E1FB" />
      </svg>
    </div>

    <!-- Nav Single -->
    <li class="nav-item nav60" (click)="toValhalla(60)" [routerLink]="['/dashboard/exam-management']">
      <a class="nav-link">
        <i class="ti-user menu-icon"></i>
        <span class="menu-title">Exams</span>
      </a>
    </li>
    <!-- Nav Single -->

    <!-- Nav Single -->
    <li class="nav-item nav70" (click)="toValhalla(70)" [routerLink]="['/dashboard/attain-management']">
      <a class="nav-link">
        <i class="ti-settings menu-icon"></i>
        <span class="menu-title">Attaiments</span>
      </a>
    </li>
    <!-- Nav Single -->


    <!-- Nav Single -->
    <!-- <li class="nav-item nav80" (click)="toValhalla(80)" [routerLink]="['/dashboard/journal-management']">
      <a class="nav-link">
        <i class="ti-bookmark-alt menu-icon"></i>
        <span class="menu-title">Work Done Register</span>
      </a>
    </li> -->
    <!-- Nav Single -->


    <!-- Nav Single -->
    <!-- <li class="nav-item nav90" *ngIf="Shop?.user_type != 2" (click)="toValhalla(90)"
      [routerLink]="['/dashboard/approval-management']">
      <a class="nav-link">
        <i class="icon-paper menu-icon"></i>
        <span class="menu-title">Pending Approvals</span>
      </a>
    </li> -->
    <!-- Nav Single -->


    <!-- Nav Single -->
    <!-- <li class="nav-item nav100" (click)="toValhalla(100)" [routerLink]="['/dashboard/notepad-management']">
      <a class="nav-link">
        <i class="ti-marker-alt menu-icon"></i>
        <span class="menu-title">Notepad</span>
      </a>
    </li> -->
    <!-- Nav Single -->






    <!-- Nav Dropdown -->
    <!-- <li class="nav-item nav10" (click)="toValhalla(10)">
      <a class="nav-e link" [routerLink]="['//dashboard/routePath' ]" routerLinkActivedashboard//="router-link-activ" data-toggle="collapse"
        href="#auth" aria-expanded="false" aria-controls="auth">
        <i class="icon-head menu-icon"></i>
        <span class="menu-title">Auth Pages</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="auth">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item nav10" (click)="toValhalla(10)"> <a class= [routerLink]="['//dashboard/signin']"> Signi"nav-link" n </a>
          </li>
          <li class="nav-item nav10" (click)="toValhalla(10)"> <a class= [routerLink]="['//dashboard/signup']"> Signu"nav-link" p </a>
          </li>
        </ul>
      </div>
    </li> -->
    <!-- Nav Dropdown -->

  </ul>
</nav>
